export default function isTouch () {
  return window.matchMedia('(pointer: coarse)').matches
}




// WEBPACK FOOTER //
// ./D:/node-prj/geoviewer2/src/util/isTouch.js